import React, { Fragment } from 'react';
import _ from 'lodash';

import {
    Card,
    CardBody,
    CardHeader,
    Collapse,
    FormGroup,
    Input,
    Label
} from 'reactstrap';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { urlify } from '../../utils';
import CollapseButton from '../dumb/collapseButton';
import baseFilter from './baseFilter';


class TissueStatusFilter extends baseFilter {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,

            filters: {
                "Metastasis": {
                    filter_name: "metastasis",
                    active: false,
                    count: 0
                },

                "Normal": {
                    filter_name: "normal",
                    active: false,
                    count: 0
                },

                "Precancerous": {
                    filter_name: "precancerous",
                    active: false,
                    count: 0
                },

                "Papiloma": {
                    filter_name: "papiloma",
                    active: false,
                    count: 0
                },

                "Tumour": {
                    filter_name: "tumour",
                    active: false,
                    count: 0
                },

                "Unknown": {
                    filter_name: "unknown",
                    active: false,
                    count: 0
                }
            },

            activeCount: 0
        };


        this.aggregates = {
            'sample.tissue_status': 'count'
        };


        this.toggleCheckbox =
            this.toggleCheckbox.bind(this);

        this.toggleCollapse =
            this.toggleCollapse.bind(this);

        this.processResponse =
            this.processResponse.bind(this);

        this.updateAPIURL =
            this.updateAPIURL.bind(this);
    }


    /**
     * Read the selected tissue statuses directly from
     * the current URL.
     */
    getActiveTissueStatuses(locationSearch) {

        const current_qs = qs.parse(
            locationSearch ||
            this.props.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        if (!current_qs.tissue_status) {
            return [];
        }


        return _.split(
            current_qs.tissue_status,
            '_'
        );
    }


    /**
     * Convert selected URL values into the API's
     * actual tissue_status values.
     */
    getActiveAPIValues(locationSearch) {

        const selected =
            this.getActiveTissueStatuses(
                locationSearch
            );


        return _.keys(this.state.filters)
            .filter(displayName => {

                return selected.indexOf(
                    urlify(displayName)
                ) !== -1;

            })
            .map(displayName => {

                return this.state.filters[
                    displayName
                ].filter_name;

            });
    }


    updateAPIURL(current_api_qs, newlistprops) {

        const activeValues =
            this.getActiveAPIValues(
                newlistprops.location.search
            );


        if (activeValues.length > 0) {

            const filter_qs = {
                name: 'sample',
                op: 'has',
                val: {
                    name: 'tissue_status',
                    op: 'in',
                    val: activeValues
                }
            };


            current_api_qs.filter = [
                ..._.get(
                    current_api_qs,
                    'filter',
                    []
                ),

                filter_qs
            ];
        }


        /*
         * Always request the aggregate so that the
         * filter has its available options/counts.
         */
        current_api_qs.agg = {
            ..._.get(
                current_api_qs,
                'agg',
                {}
            ),

            ...this.aggregates
        };


        return current_api_qs;
    }


    processResponse(response) {

        const resp_agg =
            this.get_agg_values(response);


        const agg_field =
            _.keys(this.aggregates)[0];


        const count_field =
            this.aggregates[agg_field];


        if (
            !resp_agg ||
            !resp_agg[agg_field] ||
            !resp_agg[agg_field][count_field]
        ) {
            return;
        }


        const aggregateValues =
            resp_agg[agg_field][count_field];


        const activeStatuses =
            this.getActiveTissueStatuses(
                this.props.location.search
            );


        /*
         * Start from the known list of tissue statuses.
         *
         * This is important because the API may not return
         * every status when the current filter is restrictive.
         */
        const newfilters = {};


        _.forEach(
            this.state.filters,
            (oldProps, displayName) => {

                const filterName =
                    oldProps.filter_name;


                /*
                 * API aggregate keys use the actual API value,
                 * e.g. "tumour", "normal", etc.
                 */
                let count =
                    aggregateValues[filterName];


                /*
                 * Some APIs may return display-case values
                 * instead, so fall back to the display name.
                 */
                if (_.isUndefined(count)) {
                    count =
                        aggregateValues[displayName];
                }


                newfilters[displayName] = {
                    filter_name: filterName,

                    count: _.isUndefined(count)
                        ? 0
                        : count,

                    active:
                        activeStatuses.indexOf(
                            urlify(displayName)
                        ) !== -1
                };
            }
        );


        this.setState({
            filters: newfilters,

            activeCount:
                activeStatuses.length
        });
    }


    toggleCheckbox(event) {

        const displayName =
            event.target.name;


        const tissueStatus =
            urlify(displayName);


        const current_qs =
            qs.parse(
                this.props.location.search,
                {
                    ignoreQueryPrefix: true
                }
            );


        let selected =
            current_qs.tissue_status
                ? _.split(
                    current_qs.tissue_status,
                    '_'
                )
                : [];


        if (event.target.checked) {

            if (
                selected.indexOf(
                    tissueStatus
                ) === -1
            ) {
                selected.push(
                    tissueStatus
                );
            }

        } else {

            selected = selected.filter(
                item => item !== tissueStatus
            );
        }


        selected =
            _.uniq(selected).sort();


        if (selected.length > 0) {

            current_qs.tissue_status =
                _.join(
                    selected,
                    '_'
                );

        } else {

            delete current_qs.tissue_status;
        }


        delete current_qs.page;


        this.props.history.push(
            window.location.pathname +
            qs.stringify(
                current_qs,
                {
                    addQueryPrefix: true
                }
            )
        );
    }


    toggleCollapse() {

        this.setState({
            isOpen: !this.state.isOpen
        });
    }


    renderTissueCheckboxes() {

        const filters =
            this.state.filters || {};


        let active = [];
        let inactive = [];


        _.forEach(
            _.toPairs(filters),
            ([key, filterProps]) => {

                const checkbox = (
                    <FormGroup
                        check
                        key={key}
                    >

                        <Input
                            type="checkbox"
                            name={key}
                            onChange={
                                this.toggleCheckbox
                            }
                            checked={
                                !!filterProps.active
                            }
                        />

                        {' '}

                        <Label
                            className="ml-4 mt-1"
                            check
                        >
                            {key}

                            {filterProps.count > 0 && (
                                <span className="secondary">
                                    {' '}({filterProps.count})
                                </span>
                            )}
                        </Label>

                    </FormGroup>
                );


                if (filterProps.active) {
                    active.push(checkbox);
                } else {
                    inactive.push(checkbox);
                }
            }
        );


        return (
            <Fragment>
                {active}
                {inactive}
            </Fragment>
        );
    }


    componentDidMount() {

        this.props.registerResponse(
            this.processResponse
        );

        this.props.registerRequest(
            this.updateAPIURL
        );
    }


    componentWillUnmount() {

        this.props.unregisterResponse(
            this.processResponse
        );

        this.props.unregisterRequest(
            this.updateAPIURL
        );
    }


    render() {

        return (
            <Card className="mb-2 z0 hover">

                <CardHeader
                    className="justify-content-between d-flex"
                    onClick={this.toggleCollapse}
                >

                    <div className="d-inline w-50">
                        Tissue Status
                    </div>


                    <div className="d-inline-block">

                        {this.state.activeCount > 0 && (
                            <strong>
                                {this.state.activeCount} active
                            </strong>
                        )}

                    </div>


                    <CollapseButton
                        isOpen={this.state.isOpen}
                        onClick={this.toggleCollapse}
                    />

                </CardHeader>


                <Collapse
                    isOpen={this.state.isOpen}
                >

                    <CardBody>
                        {this.renderTissueCheckboxes()}
                    </CardBody>

                </Collapse>

            </Card>
        );
    }
}


export default withRouter(TissueStatusFilter);